import React from 'react';

// Values come from the caller; no synthesized business metrics.
export default function KpiCard({ label, value, subtitle, accent = 'var(--color-primary)', size = 'md' }) {
  return <div className={`kpi-card${size === 'lg' ? ' is-large' : ''}`} style={{ '--kpi-accent': accent }}>
    <p className="kpi-label">{label}</p>
    <strong className="kpi-value">{value}</strong>
    {subtitle && <p className="kpi-subtitle">{subtitle}</p>}
    <span className="kpi-accent" aria-hidden="true"/>
  </div>;
}
